var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFile = function SvgFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 90 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.473.232H.313v109.71h88.812V27.884L61.473.232Zm1.53 8.918 17.204 17.203H63.004V9.15Zm20.898 95.567H5.537V5.457h52.242v26.12h26.122v73.14Z",
    fill: "#C5B27C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.451 52.475H15.984v5.224h57.467v-5.224ZM47.33 26.354H15.984v5.224H47.33v-5.224ZM73.451 78.596H15.984v5.225h57.467v-5.225Z",
    fill: "#C5B27C"
  })));
};
export default SvgFile;